import * as types from './types';

const initialState = {
  loading: false,
  recievedSuccessfulResponse: false,
  recievedErrorResponse: false,
  bulkSuccessful: 0,
  bulkError: 0,
  particularNotFree: false,
  isDraft: false,
  isOffline: false
};

function archiveReducer(state = initialState, action) {
  switch (action.type) {
    case types.ARCHIVE_POSTING:
      return {
        ...state,
        loading: true,
        recievedResponse: false,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: false,
        isDraft: false,
        isOffline: false,
        particularNotFree: false
      };

    case types.ARCHIVE_POSTING_COMPLETED:
      return {
        ...state,
        loading: false,
        recievedSuccessfulResponse: true,
        recievedErrorResponse: false,
        bulkSuccessful: action.payload.successfulPostings || 0,
        bulkError: action.payload.errorPostings || 0,
        particularNotFree: action.meta.particularNotFree,
        isDraft: action.meta.isDraft,
        isOffline: action.meta.isOffline
      };
    case types.ARCHIVE_POSTING_FAILED:
      return {
        ...state,
        loading: false,
        recievedSuccessfulResponse: false,
        recievedErrorResponse: true,
        bulkError: action.meta.body.length || 1,
        particularNotFree: false,
        isDraft: action.meta.isDraft,
        isOffline: false
      };

    case types.RESET_ARCHIVE_POSTING:
      return {
        ...state,
        ...initialState,
        isDraft: state.isDraft
      };
    default:
      return state;
  }
}

export default archiveReducer;
